import { mapRatioTable, ratioPrecision, referencePeriodOf } from './domain';
import type { EnergyKey, PerformanceTable, PeriodKey, RatioTable, UsageKey } from './types';

export const PERF_MIN = 1;
export const PERF_MAX = 100;
export const isValidPerf = (v: number) => Number.isFinite(v) && v >= PERF_MIN && v <= PERF_MAX;

/** Sans métadonnées (anciens projets), lire chaque poste sans réécrire ses ratios arrondis. */
export function perfOf(t: RatioTable, u: UsageKey, p: PeriodKey, e: EnergyKey): number | null {
  const REF_PERIOD = referencePeriodOf(t);
  if (p === REF_PERIOD) return 100;
  if (t.performance?.[u]?.[p]) return t.performance[u][p][e];
  const ref = t[u]?.[REF_PERIOD]?.[e];
  const ratio = t[u]?.[p]?.[e];
  return ref != null && ref > 0 && ratio != null ? Math.round((ratio / ref) * 1000) / 10 : null;
}

export const perfTableOf = (t: RatioTable): PerformanceTable =>
  mapRatioTable((u, p) => ({
    chauffage: perfOf(t, u, p, 'chauffage'), ecs: perfOf(t, u, p, 'ecs'), froid: perfOf(t, u, p, 'froid'),
  }));

/** Un seul poste change ; conserver le coefficient exact malgré l'arrondi du ratio à une décimale. */
export function setPerf(t: RatioTable, u: UsageKey, p: PeriodKey, e: EnergyKey, percent: number): RatioTable {
  const REF_PERIOD = referencePeriodOf(t);
  if (p === REF_PERIOD) return t;
  const performance = perfTableOf(t);
  performance[u][p][e] = percent;
  return {
    ...t, performance,
    [u]: { ...t[u], [p]: { ...t[u][p], [e]: t[u][REF_PERIOD][e] === null ? null : ratioPrecision(t, t[u][REF_PERIOD][e] * (percent / 100)) } },
  };
}
